var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProfileClose = function SvgIconProfileClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3038",
    fillRule: "evenodd",
    d: "M15.45 4.55a1.104 1.104 0 0 0-1.561 0l-3.89 3.889L6.112 4.55a1.104 1.104 0 1 0-1.562 1.562L8.438 10 4.55 13.89a1.104 1.104 0 0 0 1.562 1.561L10 11.562l3.889 3.89a1.104 1.104 0 1 0 1.561-1.562L11.561 10l3.89-3.889a1.104 1.104 0 0 0 0-1.561",
    clipRule: "evenodd"
  })));
};
export default SvgIconProfileClose;